export default {
  "site.name": "成人动漫精选推荐",
  "site.slogan": "探索成人动漫的精彩世界",
  "site.description": "汇聚高分成人动漫作品推荐、类型解析与观看指南",
  "nav.home": "首页",
  "nav.category": "分类浏览",
  "nav.about": "关于我们",
  "nav.search": "搜索作品...",
  "hero.title": "发现值得一看的",
  "hero.titleHighlight": "成人动漫杰作",
  "hero.subtitle": "汇聚高分成人动漫作品推荐、深度解析与观看指南，帮你快速找到符合口味的优质作品",
  "hero.cta": "开始探索",
  "hero.secondary": "浏览分类",
  "section.featured": "精选推荐",
  "section.featured.desc": "经过精心筛选的高分成人动漫作品，每一部都值得细细品味",
  "section.categories": "类型分类",
  "section.categories.desc": "按类型探索，找到你最感兴趣的动漫作品",
  "section.articles": "最新推荐",
  "section.articles.desc": "持续更新的成人动漫推荐与深度解析",
  "section.faq": "常见问题",
  "section.faq.desc": "关于成人动漫的常见疑问解答",
  "article.readMore": "阅读全文",
  "article.rating": "评分",
  "article.genre": "类型",
  "article.episodes": "集数",
  "article.year": "年份",
  "article.watchGuide": "观看指南",
  "article.synopsis": "剧情简介",
  "article.characters": "主要角色",
  "article.reviews": "观众评价",
  "category.all": "全部",
  "category.mystery": "悬疑推理",
  "category.scifi": "科幻奇幻",
  "category.psychological": "心理惊悚",
  "category.romance": "爱情剧情",
  "category.action": "动作冒险",
  "category.historical": "历史战争",
  "footer.about": "成人动漫精选推荐致力于为华语观众提供高质量的成人动漫作品推荐与观看指南，帮助你发现值得一看的佳作。",
  "footer.quickLinks": "快速链接",
  "footer.categories": "热门分类",
  "footer.contact": "联系我们",
  "footer.copyright": "成人动漫精选推荐 版权所有",
  "about.title": "关于我们",
  "about.subtitle": "成人动漫精选推荐",
  "about.intro": "我们是一个专注于成人动漫作品推荐与解析的团队，致力于为华语观众筛选最优质的成人动漫内容。",
  "about.mission": "我们的使命",
  "about.mission.text": "让每一位动漫爱好者都能找到符合自己口味的优质成人动漫作品，不再浪费时间在海量内容中盲目寻找。",
  "about.reputation": "我们的信誉",
  "about.reputation.text": "所有推荐作品均经过团队严格筛选与深度评测，评分标准公开透明，确保推荐质量。",
  "about.contact": "联系我们",
  "about.contact.desc": "如果你有任何建议、合作意向或者想推荐优秀的成人动漫作品，欢迎通过以下方式联系我们。",
  "breadcrumb.home": "首页",
  "breadcrumb.category": "分类",
  "scrollToTop": "回到顶部",
  "search.placeholder": "输入作品名称搜索...",
  "noResults": "暂无相关内容",
  "loading": "加载中...",
};